<template>
  <div :class="$style.app">
    <EndScreen
      v-bind="$attrs.end"
      :stars="3"
      noRetry
      inline
      @end="$emit('finish')"
    />
  </div>
</template>

<script>
import EndScreen from '@/components/EndScreen'
import * as localStorage from '@/utils/local-storage'

import 'animate.css/animate.css'

export default {
  setup (_, context) {
    localStorage.setGameItem(context.attrs.gameId, 'stars', 3)
  },
  components: {
    EndScreen,
  },
}
</script>

<style module lang="scss">
.app {
  :global {
    @import '~@/style/global';
    @include root-styles;
  }
}
</style>
